export default __webpack_public_path__ + "static/media/Pattern.6981e1d6.png";